import { saveAs } from 'file-saver'
import { useDispatch } from 'react-redux'

//UI

import { NonFormUpload } from '@/components/Elements'
import { Button, Flex, Heading, HStack, Spacer } from '@chakra-ui/react'
import { toast } from 'react-toastify'

//Hook
import { useCustomer } from '@/features/customers/useCustomer'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

//Helper
import { createExcelBlob } from '@/utils/fileHelper'

const CustomerListHeader = ({ handleAddCustomer }) => {
  //Hooks

  const dispatch = useDispatch()
  const { useFetchAllCustomers, useUploadCustomers } = useCustomer()
  const uploadCustomers = useUploadCustomers()

  const { data: allCustomersResponse } = useFetchAllCustomers({
    page: 1,
    pageSize: 0,
  }) // Page Size 0 means get all

  const handleUpload = (file) => {
    if (!file) {
      toast.error('No File Uploaded')
      return
    }
    dispatch(showLoadingOverlay())
    uploadCustomers.mutate(file, {
      onSettled: () => {
        dispatch(hideLoadingOverlay())
      },
    })
  }

  const handleDownloadAllCustomer = () => {
    try {
      const excelData = allCustomersResponse.data.map((row) => ({
        code: row.code,
        name: row.name,
        businessRegistrationNumber: row.businessRegistrationNumber,
        SAPStatus: row.SAPStatus.toLowerCase(),
        status: row.status.toLowerCase(),
      }))
      const excelBlob = createExcelBlob(excelData)
      saveAs(excelBlob, 'Customers.xlsx')
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <>
      <Flex p={5} borderBottom="1px solid #d8dbe0">
        <Heading>Customer</Heading>
        <HStack mx="5">
          <Button colorScheme="gray" onClick={handleDownloadAllCustomer}>
            Download
          </Button>
          <NonFormUpload uploadHandler={handleUpload} />
        </HStack>
        <Spacer />
        <Button colorScheme="blue" onClick={handleAddCustomer}>
          Add Customer
        </Button>
      </Flex>
    </>
  )
}

export default CustomerListHeader
